import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { adminAPI } from '../../utils/api';
import { DashboardLayout } from '../../components/layout';
import { StatCard, Spinner, StatusBadge, EmptyState } from '../../components/ui';

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminAPI.getStats().then(r=>setStats(r.data.stats)).catch(()=>{}).finally(()=>setLoading(false));
  }, []);

  if (loading) return <DashboardLayout title="Admin Dashboard" isAdmin><div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:400 }}><Spinner size={40} color="blue" /></div></DashboardLayout>;

  return (
    <DashboardLayout title="Admin Dashboard" subtitle="TNPSC Hub Control Panel" isAdmin
      actions={<Link to="/admin/questions" className="btn btn-gold btn-sm">+ Add Question</Link>}>

      {stats?.pending_payments>0 && (
        <div style={{ background:'rgba(245,166,35,0.07)',border:'1px solid rgba(245,166,35,0.28)',borderRadius:14,padding:'13px 18px',marginBottom:22,display:'flex',alignItems:'center',justifyContent:'space-between',flexWrap:'wrap',gap:10 }}>
          <div style={{ display:'flex',alignItems:'center',gap:10 }}>
            <span style={{ fontSize:20 }}>⚡</span>
            <div>
              <div style={{ fontWeight:700,color:'var(--dark)',fontSize:14 }}>{stats.pending_payments} Payment{stats.pending_payments>1?'s':''} Awaiting Approval</div>
              <div style={{ fontSize:12,color:'var(--muted)' }}>Verify UTR IDs and approve to activate accounts</div>
            </div>
          </div>
          <Link to="/admin/payments" className="btn btn-gold btn-sm">Review →</Link>
        </div>
      )}

      <div className="g4" style={{ marginBottom:24 }}>
        <StatCard icon="👥" label="Total Users" value={stats?.total_users||0} sub={`${stats?.active_users||0} active`} color="blue" />
        <StatCard icon="⏳" label="Pending" value={stats?.pending_users||0} sub="Awaiting approval" color="gold" />
        <StatCard icon="❓" label="Questions" value={(stats?.total_questions||0).toLocaleString()} color="green" />
        <StatCard icon="📝" label="Tests Taken" value={stats?.total_tests_taken||0} color="blue" />
      </div>

      <div className="g2">
        {/* Recent Registrations */}
        <div className="card">
          <div className="card-header">
            <h3 style={{ fontSize:15,fontWeight:700 }}>👥 Recent Registrations</h3>
            <Link to="/admin/users" className="btn btn-outline btn-sm">View All</Link>
          </div>
          {stats?.recent_users?.length>0 ? stats.recent_users.slice(0,6).map(u => (
            <div key={u.id} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',padding:'11px 22px',borderBottom:'1px solid var(--border)' }}>
              <div style={{ display:'flex',alignItems:'center',gap:10 }}>
                <div style={{ width:34,height:34,borderRadius:'50%',background:'linear-gradient(135deg,var(--blue),var(--blue-mid))',display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontSize:13,fontWeight:700,flexShrink:0 }}>{u.full_name[0]}</div>
                <div>
                  <div style={{ fontSize:13,fontWeight:600 }}>{u.full_name}</div>
                  <div style={{ fontSize:11,color:'var(--muted)' }}>{u.exam_group} • {new Date(u.created_at).toLocaleDateString('en-IN')}</div>
                </div>
              </div>
              <StatusBadge status={u.status} />
            </div>
          )) : <EmptyState icon="👥" title="No users yet" />}
        </div>

        {/* Quick Links */}
        <div style={{ display:'flex',flexDirection:'column',gap:16 }}>
          <div className="card">
            <div className="card-header"><h3 style={{ fontSize:15,fontWeight:700 }}>⚡ Quick Actions</h3></div>
            <div className="card-body" style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:10 }}>
              {[{to:'/admin/questions',ic:'❓',l:'Questions',c:'var(--blue)'},{to:'/admin/payments',ic:'💰',l:'Payments',c:'var(--gold-dark)'},{to:'/admin/users',ic:'👥',l:'Users',c:'var(--success)'},{to:'/admin/tests',ic:'📝',l:'Tests',c:'#6f42c1'}].map(a => (
                <Link key={a.to} to={a.to} style={{ display:'flex',flexDirection:'column',alignItems:'center',gap:7,padding:'18px 10px',background:'var(--bg)',borderRadius:11,border:'1px solid var(--border)',textDecoration:'none',transition:'var(--transition)',textAlign:'center' }}
                  onMouseEnter={e=>{ e.currentTarget.style.background='rgba(26,60,143,0.04)'; e.currentTarget.style.borderColor='rgba(26,60,143,0.22)'; }}
                  onMouseLeave={e=>{ e.currentTarget.style.background='var(--bg)'; e.currentTarget.style.borderColor='var(--border)'; }}>
                  <span style={{ fontSize:26 }}>{a.ic}</span>
                  <span style={{ fontSize:12,fontWeight:600,color:a.c }}>{a.l}</span>
                </Link>
              ))}
            </div>
          </div>

          <div style={{ background:'linear-gradient(135deg,var(--blue-dark),var(--blue))',borderRadius:14,padding:'18px 20px',color:'#fff' }}>
            <div style={{ fontSize:12,fontWeight:600,opacity:0.6,marginBottom:8 }}>💡 Quick Stats</div>
            <div style={{ display:'grid',gridTemplateColumns:'1fr 1fr',gap:12 }}>
              {[['Group 1',stats?.by_group?.find(g=>g.exam_group==='Group1')?.count||0],['Group 2',stats?.by_group?.find(g=>g.exam_group==='Group2')?.count||0],['Group 2A',stats?.by_group?.find(g=>g.exam_group==='Group2A')?.count||0],['Group 4',stats?.by_group?.find(g=>g.exam_group==='Group4')?.count||0]].map(([l,v]) => (
                <div key={l}>
                  <div style={{ fontFamily:'var(--font-mono)',fontSize:18,fontWeight:700,color:'#fff' }}>{v}</div>
                  <div style={{ fontSize:11,opacity:0.55 }}>{l} users</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>
  );
}
